import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, scroller, Element } from 'react-scroll'
import LazyLoad from 'react-lazyload'
import Tooltip from '@material-ui/core/Tooltip'
import NoSsr from '@material-ui/core/NoSsr'
import ControlTooltip from './ControlTooltip'
import ControlClose from './ControlClose'
import ClipartsIcon from '../../../../icons/ClipartsIcon'
import { clipartsSelector, drawControlPopupSelector } from '../../selectors'
import { addPictureToCanvas } from '../../AC/add-picture-to-canvas'

const POPUP_NAME = 'CLIPARTS'

Cliparts.propTypes = {
  cliparts: PropTypes.object,
  addPictureToCanvas: PropTypes.func,
}

function Cliparts(props) {
  const addClipart = (params) => () => {
    props.addPictureToCanvas(params, {
      isClipart: true,
    })
  }

  const scrollToCategory = (category) => () => {
    scroller.scrollTo(category, {
      containerId: `container`,
      smooth: true,
    })
  }

  const { cliparts, drawControlPopup } = props

  const categories = {
    '00-halloween': {
      title: `Хеллоуин`,
      icon: 38,
    },
    '01-top': {
      title: `популярные`,
      icon: 2,
    },
    '02-hearts': {
      title: `сердца`,
      icon: 1,
    },
    '03-crowns': {
      title: `короны`,
      icon: 0,
    },
    '04-skulls': {
      title: `черепа`,
      icon: 0,
    },
    '05-others': {
      title: `разное`,
      icon: 8,
    },
  }
  return (
    <NoSsr>
      <ControlTooltip
        popupName={POPUP_NAME}
        icon={<ClipartsIcon />}
        title={'Клипарты'}
      />
      {drawControlPopup === POPUP_NAME && (
        <div className="panel-popup">
          <div className="panel-popup__header">
            <div className="cliparts-links">
              {Object.keys(cliparts)
                .sort()
                .filter((category) => cliparts[category].length)
                .map((category) => {
                  const { title, icon } = categories[category]
                  return (
                    <Tooltip key={category} title={title}>
                      <Link
                        spy={true}
                        smooth={true}
                        containerId="container"
                        activeClass="active"
                        offset={-45}
                        to={category}
                        className="cliparts-links__item"
                        onClick={scrollToCategory(category)}
                      >
                        <img
                          loading="lazy"
                          src={cliparts[category][icon].preview}
                        />
                      </Link>
                    </Tooltip>
                  )
                })}
            </div>
          </div>
          <Element
            className="cliparts cliparts-list panel-popup__content"
            id="container"
          >
            {Object.keys(cliparts)
              .sort()
              .filter((category) => cliparts[category].length)
              .map((category) => {
                const { title } = categories[category]
                return (
                  <Element key={category} name={category}>
                    <div className="cliparts-list__header">{title}</div>
                    <div className="cliparts-list__content">
                      {cliparts[category].map(
                        ({ id, type, preview, original }) => (
                          <div
                            key={id}
                            className="cliparts-list__item"
                            onClick={addClipart({
                              type,
                              original,
                            })}
                          >
                            <LazyLoad
                              once
                              overflow={true}
                              height={60}
                              offset={60}
                            >
                              <img loading="lazy" src={preview} />
                            </LazyLoad>
                          </div>
                        )
                      )}
                    </div>
                  </Element>
                )
              })}
          </Element>
          <ControlClose />
        </div>
      )}
    </NoSsr>
  )
}

const mapStateToProps = (state) => ({
  cliparts: clipartsSelector(state),
  drawControlPopup: drawControlPopupSelector(state),
})

const mapDispatchToProps = {
  addPictureToCanvas,
}

export default connect(mapStateToProps, mapDispatchToProps)(Cliparts)
